<h2 class="section_header">{{ 'login.quickAccessLink.header' | translate }}</h2>

<div class="col-12 bubbleCardContainer">
  <div class="row">
    <div class="col-12 col-lg-3 col-sm-6">
      <div class="icon cg-margin-bottom-md">
        <cigna-icon type="medical-form" class="bubbleIcon"></cigna-icon>
      </div>
      <div class="title cg-margin-bottom-md">
        <h3>{{ 'login.quickAccessLink.resources.formTitle' | translate }}</h3>
      </div>
      <div class="content">
        <p>
          <a
            target="resourcesWindow"
            [href]="
              '/resourceLibrary/formsCenter'
                | resourceLink: { secure: false }
                | async
            "
            [cignaTrackClicks]="[
              'trackEventOther',
              'Quickly locate the forms you need',
              'ac-Login009-US1023762-Locate Forms'
            ]"
            >Quickly locate the forms you need</a
          >
          for authorizations, referrals, or filing or appealing claims with our
          Forms resource area.
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-3 col-sm-6">
      <div class="icon cg-margin-bottom-md">
        <cigna-icon type="laptop" class="bubbleIcon"></cigna-icon>
      </div>
      <div class="title cg-margin-bottom-md">
        <h3>
          {{ 'login.quickAccessLink.resources.coverageTitle' | translate }}
        </h3>
      </div>
      <div class="content">
        <p>
          Access
          <a
            target="resourcesWindow"
            [cignaTrackClicks]="[
              'trackEventOther',
              'information on Cigna standard health coverage plan provisions',
              'ac-Login010-US1023762-Information On'
            ]"
            [href]="
              '/resourceLibrary/coveragePolicies/index'
                | resourceLink: { secure: false }
                | async
            "
            >information on Cigna standard health coverage plan provisions</a
          >
          and medical coverage policies with our extensive Coverage Policies
          resource area.
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-3 col-sm-6">
      <div class="icon cg-margin-bottom-md">
        <cigna-icon type="calculator" class="bubbleIcon"></cigna-icon>
      </div>
      <div class="title cg-margin-bottom-md">
        <h3>
          {{ 'login.quickAccessLink.resources.clinicalTitle' | translate }}
        </h3>
      </div>
      <div class="content">
        <p>
          Find
          <a
            target="resourcesWindow"
            [cignaTrackClicks]="[
              'trackEventOther',
              'appeal policies, claim editing procedures and laboratory and reimbursement information',
              'ac-Login011-US1023762-Appeal Policies'
            ]"
            [href]="
              '/resourceLibrary/clinicalReimbursementPayment/clinReimAndPayPolsListing'
                | resourceLink: { secure: false }
                | async
            "
            >appeal policies, claim editing procedures and laboratory and
            reimbursement information</a
          >
          critical to working with Cigna.
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-3 col-sm-6">
      <div class="icon cg-margin-bottom-md">
        <cigna-icon type="lightbulb-off" class="bubbleIcon"></cigna-icon>
      </div>
      <div class="title cg-margin-bottom-md">
        <h3>
          {{
            'login.quickAccessLink.resources.precertificationTitle' | translate
          }}
        </h3>
      </div>
      <div class="content">
        <p>
          <a
            target="resourcesWindow"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Learn what services require precertification',
              'ac-Login012-US1023764-Learn Services'
            ]"
            [href]="
              '/resourceLibrary/preCertification/preCertification'
                | resourceLink: { secure: false }
                | async
            "
            >Learn what services require precertification</a
          >
          and how to properly request it for medications, medical procedures,
          and services managed by delegated ancillary vendors.
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-3 col-sm-6">
      <div class="icon cg-margin-bottom-md">
        <cigna-icon type="tablet" class="bubbleIcon"></cigna-icon>
      </div>
      <div class="title cg-margin-bottom-md">
        <h3>
          {{ 'login.quickAccessLink.resources.getQuesAnsTitle' | translate }}
        </h3>
      </div>
      <div class="content">
        <p>
          Our
          <a
            target="resourcesWindow"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Resource library',
              'ac-Login013-US1023764-Resource Library'
            ]"
            [href]="
              '/resourceLibrary/resourceLibrary'
                | resourceLink: { secure: false }
                | async
            "
            >Resource</a
          >
          library has access to many forms and information that you can access
          before logging in.
        </p>
      </div>
    </div>
    <div class="col-12 col-lg-3 col-sm-6">
      <div class="icon cg-margin-bottom-md">
        <cigna-icon type="earth" class="bubbleIcon"></cigna-icon>
      </div>
      <div class="title cg-margin-bottom-md">
        <h3>
          {{ 'login.quickAccessLink.resources.joinCignaTitle' | translate }}
        </h3>
      </div>
      <div class="content">
        <p>
          Become a contracted Cigna provider! Choose your field to get started:
          <a
            target="resourcesWindow"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Medical',
              'Login016-US1012725-Medical Join',
              { prop20: 'Join the Cigna Network' }
            ]"
            [href]="
              '/resourceLibrary/medicalResourcesList/medicalDoingBusinessWithCigna/medicalDBwCCredentialRecredential'
                | resourceLink: { secure: false }
                | async
            "
            >Medical</a
          >,
          <a
            target="_blank"
            rel="noopener noreferrer"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Dental',
              'ac-Login017-US1012725-Dental Join',
              { prop20: 'Join the Cigna Network' }
            ]"
            href="https://www.cigna.com/health-care-providers/credentialing/join-dental-network"
            >Dental</a
          >
          or
          <a
            target="resourcesWindow"
            [cignaTrackClicks]="[
              'trackEventOther',
              'Behavioral',
              'ac-Login018-US1012725-Behavioral Join',
              { prop20: 'Join the Cigna Network' }
            ]"
            [href]="
              '/resourceLibrary/behavioralResources/doingBusinessWithUs/cbhCredentialing'
                | resourceLink: { secure: false, targetApp: 'evernorth' }
                | async
            "
            >Behavioral</a
          >.
        </p>
      </div>
    </div>
  </div>
</div>
